module.exports = __webpack_public_path__ + "static/img/login_avator.18b9f24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_avator.png
// module id = Lswv
// module chunks = 4